import upperFirst from 'lodash/upperFirst.js';
import * as agentMessagePayload from "./agent-message-payload.js";
import * as agentSessionPayload from "./agent-session-payload.js";
export const schema = {
    type: 'object',
    properties: {
        session: {
            ...agentSessionPayload.schema
        },
        history: {
            type: 'array',
            items: {
                type: 'object'
            },
            description: 'A history of agent responses in the session.'
        },
        messages: {
            type: 'array',
            items: {
                ...agentMessagePayload.schema
            },
            description: 'A list of messages exchanged in the agent session, which may include user inputs and agent responses.'
        }
    },
    required: ['history', 'session', 'messages'],
    additionalProperties: false
};
export function createUserShapeSchema() {
    return {
        ...schema,
        properties: {
            ...schema.properties,
            session: {
                '@ref': agentSessionPayload.shapeName
            },
            messages: {
                ...schema.properties.messages,
                items: {
                    '@ref': agentMessagePayload.shapeName
                }
            }
        },
        additionalProperties: false
    };
}
export function createUserShapeName(agentName) {
    return `${upperFirst(agentName)}InspectAgentResponse`;
}
